import { render, staticRenderFns } from "./MedicalNavigation.vue?vue&type=template&id=ba380202&scoped=true&"
import script from "./MedicalNavigation.vue?vue&type=script&lang=js&"
export * from "./MedicalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MedicalNavigation.vue?vue&type=style&index=0&id=ba380202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba380202",
  null
  
)

export default component.exports